import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { AddOffer, Recommendations } from '../../components/Recommendations';
import { RealtorDemandContainer } from './containers/RealtorDemandContainer';
import { defaultRefWrapper, TRefWrapper } from '../Scrolling';
import { useTrackRealtorDemand } from './utils';
import { trackAddOfferClick, trackAddOfferVisible } from './tracking';
import { selectPageType } from '../../selectors/page';
import { useAddOfferTitle } from './utils/useAddOfferTitle';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';

interface IRecommendationsContainerProps {
  refWrapper?: TRefWrapper;
}

export function RecommendationsContainer({ refWrapper = defaultRefWrapper }: IRecommendationsContainerProps): React.JSX.Element {
  const { trackDemandViewed } = useTrackRealtorDemand();
  const page = useSelector(selectPageType);
  const addOfferTitle = useAddOfferTitle();

  return refWrapper(
    <Recommendations
      addForm={
        <ActionAfterViewObserver callback={trackAddOfferVisible} wrapper={false} callbackDelay={VIEWED_TIMEOUT}>
          <AddOffer title={addOfferTitle} onActionClick={() => trackAddOfferClick(page)} />
        </ActionAfterViewObserver>
      }
      demandRequest={
        <ActionAfterViewObserver callback={trackDemandViewed} wrapper={false} callbackDelay={VIEWED_TIMEOUT}>
          <RealtorDemandContainer />
        </ActionAfterViewObserver>
      }
    />,
  );
}
